import DimensionListsDetails from './DimensionListsDetails';

export default DimensionListsDetails;
